import * as React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

export const Dashboard = () => {
  return (
    <Card>
      <CardHeader title="Welcome to the becase admin" />
      <CardContent>Wish becase have all the best!</CardContent>
    </Card>
  );
};
